// removed by extract-text-webpack-plugin
module.exports = {"page":"Page__page___390OU","wrapper":"Page__wrapper___MbE_s","facebook":"Page__facebook___1KhAe","buttons":"Page__buttons___3J6ev","email":"Page__email___3EKgx","login":"Page__login___QLspZ","background":"Page__background___3qjQ5","woman":"Page__woman___24Ssz"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Signup/Page.scss
// module id = eyzz
// module chunks = 0